import { Chip, Link, Stack, Typography } from '@mui/material'

const ATTRIBUTIONS = [
  {
    name: 'lightweight-charts',
    version: 'v5.1.0',
    author: 'TradingView, Inc.',
    license: 'Apache 2.0',
    description: 'TradingView Lightweight Charts™',
    url: 'https://www.tradingview.com/',
    urlLabel: 'tradingview.com',
  },
]

const AttributionItem = ({
  name,
  version,
  author,
  license,
  description,
  url,
  urlLabel,
}) => (
  <Stack gap={0.5}>
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={1}
      flexWrap="wrap"
    >
      <Stack>
        <Typography variant="body1" fontWeight="bold">
          {name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {version} | {author}
        </Typography>
      </Stack>
      <Chip label={license} size="small" variant="outlined" />
    </Stack>
    <Typography variant="body2" color="text.secondary">
      {description}
      {url && (
        <>
          {' '}
          |{' '}
          <Link href={url} target="_blank" rel="noopener noreferrer">
            {urlLabel ?? url}
          </Link>
        </>
      )}
    </Typography>
  </Stack>
)

const Credits = () => {
  return (
    <Stack gap={2}>
      <Typography variant="subtitle2" color="text.secondary">
        Open Source Libraries
      </Typography>
      <Stack gap={1.5}>
        {ATTRIBUTIONS.map((item) => (
          <AttributionItem key={item.name} {...item} />
        ))}
      </Stack>
    </Stack>
  )
}

export default Credits
